import { Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { PLACEHOLDER_SAMPLE_DATA } from '../../consts';

const { TextArea } = Input;

/**
 * Text area that contains sample data as JSON. This receives the actual sample data
 * as a prop from dataSourceContainer, and sets the value of the text area whenever
 * the component is mounted.
 */
class DataSourceTextArea extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onChangeSampleData: PropTypes.func.isRequired,
    parseError: PropTypes.bool.isRequired,
    sampleDataValue: PropTypes.string.isRequired,
    wideView: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { id, sampleDataValue } = this.props;
    document.getElementById(id).value = sampleDataValue;
    document.getElementById(id).innerText = sampleDataValue;
  }

  // Set value of text area on both mount and update.
  componentDidUpdate() {
    const { id, sampleDataValue } = this.props;
    document.getElementById(id).value = sampleDataValue;
    document.getElementById(id).innerText = sampleDataValue;
  }

  render() {
    const { id, onChangeSampleData, parseError, wideView } = this.props;
    const isParseErrorClass = parseError ? 'parse-error-border' : '';
    return (
      <TextArea
        allowClear
        id={id}
        rows={25}
        className={isParseErrorClass}
        data-cy="editable-table-sample-data-textarea"
        bordered={false}
        showCount
        placeholder={JSON.stringify(wideView ? {} : PLACEHOLDER_SAMPLE_DATA, null, 2)}
        maxLength={500000}
        onBlur={onChangeSampleData}
      />
    );
  }
}

export default DataSourceTextArea;
